<div class="container">
    <mat-form-field style="margin-right: 20px" appearance="outline">
        <mat-label>Enter week date range</mat-label>
        <mat-date-range-input  [rangePicker]="picker">
            <input matStartDate [(ngModel)]="startDate1" placeholder="Start date">
            <input matEndDate [(ngModel)]="endDate1" placeholder="End date">
        </mat-date-range-input>
        <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="SearchData()">SEARCH</button>
    <table mat-table [dataSource]="dataSource" matSort id="excel-table">

        <!-- Position Column -->
        <ng-container matColumnDef="centername">
            <th mat-header-cell *matHeaderCellDef> Centre Name</th>
            <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"
                [matTooltip]="element.centreCode"> {{element?.centreName}} </td>
            <!--                <td mat-footer-cell *matFooterCellDef><strong> Total</strong> </td>-->

        </ng-container>


        <!-- Available Units  Column -->
        <ng-container matColumnDef="availableunits">
            <th mat-header-cell *matHeaderCellDef> Available </th>
            <td mat-cell *matCellDef="let element"
                [ngClass]="element.isArchive?'archived':'normal'"> {{element?.Available}}   </td>
            <!--                <td mat-footer-cell *matFooterCellDef> <strong>{{lastRow?.availableUnits}}</strong> </td>-->

        </ng-container>
        <!-- Weight Column -->
        <ng-container matColumnDef="occupiedunits">
            <th mat-header-cell *matHeaderCellDef> Occupied As Of  <br>{{startDate1 |date:'dd/MM/yyyy'}} </th>
            <td mat-cell *matCellDef="let element"
                [ngClass]="element.isArchive?'archived':'normal'"> {{element?.occupied}} </td>
            <!--                <td mat-footer-cell *matFooterCellDef><strong> {{lastRow?.occupiedUnits}}</strong> </td>-->

        </ng-container>
        <ng-container matColumnDef="occupiedunitsEnd">
            <th mat-header-cell *matHeaderCellDef> Occupied As Of <br> {{endDate1 |date:'dd/MM/yyyy'}} </th>
            <td mat-cell *matCellDef="let element"
                [ngClass]="element.isArchive?'archived':'normal'"> {{element?.OccupiedEnd}} </td>
            <!--                <td mat-footer-cell *matFooterCellDef><strong> {{lastRow?.occupiedUnits}}</strong> </td>-->

        </ng-container>
        <ng-container matColumnDef="difference">
            <th mat-header-cell *matHeaderCellDef> Difference  </th>
            <td mat-cell *matCellDef="let element"
                [ngClass]="element.isArchive?'archived':'normal'"> {{element.Occupied - element?.OccupiedEnd}} </td>
            <!--                <td mat-footer-cell *matFooterCellDef><strong> {{lastRow?.occupiedUnits}}</strong> </td>-->

        </ng-container>
        <!-- Weight Column -->
        <ng-container matColumnDef="totalunits">
            <th mat-header-cell *matHeaderCellDef> Total Rooms</th>
            <td mat-cell *matCellDef="let element"
                [ngClass]="element.isArchive?'archived':'normal'"> {{element?.totalRooms}} </td>
            <!--                <td mat-footer-cell *matFooterCellDef><strong> {{lastRow?.totalUnits}}</strong> </td>-->

        </ng-container>
        <ng-container matColumnDef="percentage">
            <th mat-header-cell *matHeaderCellDef> Occupancy %</th>
            <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive ? 'archived' : 'normal'">
                <span *ngIf="element">{{ element.Occupancy | number:'1.1-1'}}%</span>
            </td>

            <!--                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>-->

        </ng-container>

        <ng-container matColumnDef="admission">
            <th mat-header-cell *matHeaderCellDef> New Admission</th>
            <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element">  {{element.uniqueAdmission !== 0 ? element.uniqueAdmission : '-'}}</span></td>
            <!--                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>-->

        </ng-container>
        <ng-container matColumnDef="discharge">
            <th mat-header-cell *matHeaderCellDef> Discharge</th>
            <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element">  {{element.uniqueDischarge !== 0 ? element.uniqueDischarge : '-'}}</span></td>
            <!--                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>-->

        </ng-container>
        <ng-container matColumnDef="fAdmission">
            <th mat-header-cell *matHeaderCellDef> Follow Up Admission</th>
            <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element">  {{element.followUpAdmission !== 0 ? element.followUpAdmission : '-'}}</span></td>
            <!--                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>-->

        </ng-container>
        <ng-container matColumnDef="fDischarge">
            <th mat-header-cell *matHeaderCellDef> Follow Up Discharge</th>
            <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element">  {{element.followupDischarge !== 0 ? element.followupDischarge : '-'}}</span></td>
            <!--                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>-->

        </ng-container>
        <ng-container matColumnDef="os">
            <th mat-header-cell *matHeaderCellDef> OS</th>
            <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element">  {{element.os!== 0 ? element.os : '-'}}</span></td>
            <!--                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>-->

        </ng-container>
        <ng-container matColumnDef="weekId">
            <th mat-header-cell *matHeaderCellDef> WeekId</th>
            <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element"> {{element.weekId}}</span></td>
            <!--                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>-->

        </ng-container>
        <ng-container matColumnDef="alchamp">
            <th mat-header-cell *matHeaderCellDef> Always Champion</th>
            <td mat-cell *matCellDef="let element" [ngClass]="element.isArchive?'archived':'normal'"> <span *ngIf="element">  {{element.alwaysChamp!== 0 ? element.alwaysChamp : '-'}}</span></td>
            <!--                <td mat-footer-cell *matFooterCellDef><span> <strong *ngIf="lastRow"> {{getPercentage(lastRow!)}}%</strong></span> </td>-->

        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <!--            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>-->

        <!-- Row shown when there is no matching data. -->
        <!--            <tr *matNoDataRow class="mat-row">-->
        <!--                <td class="mat-cell" colspan="4"  >No data matching the filter "{{input.value}}"</td>-->
        <!--            </tr>-->
    </table>

    <prettyjson [obj]="mWeekly"></prettyjson>
</div>
